export const STRING = {
  DISCOUNTTYPE: {
    FIXCARTDISCOUNT: "Fix Cart Discount",
    PERCENTAGEDISCOUNT: "Percentage Discount",
  },
  ROLE: {
    HOSTS: "Host",
    ADMIN: "Admin",
  },
  PAYMENT_TYPE: {
    PAY_TO_HOST: "Pay To Event Host",
    CARD: "Card",
    ZELLE: "Zelle",
    ISSUE_FREE_TICKET: "Issue Free Ticket",
  },
  PAYMENT_TYPE_ID: {
    PAY_TO_HOST: 2,
    CARD: 1,
    ZELLE: 1002,
    ISSUE_FREE_TICKET: 2002,
  },
};
